export default __webpack_public_path__ + "static/media/logo.350b8e36.svg";